import { render, staticRenderFns } from "./SitchTooltip.vue?vue&type=template&id=8822e2b4&scoped=true&"
import script from "./SitchTooltip.vue?vue&type=script&lang=ts&"
export * from "./SitchTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./SitchTooltip.vue?vue&type=style&index=0&id=8822e2b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8822e2b4",
  null
  
)

export default component.exports